
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import CloseSVG from '@/components/CloseSVG.vue';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: { CloseSVG }
	})
	export default class Modal extends Vue {
		@Prop() title?: string;
		@Prop({ default: true }) closeButton?: boolean;
		@Prop({ default: 110 }) zIndex?: number;
		@Prop({ default: 100 }) widthPercent?: number;
		@Prop({ default: 100 }) titleFontSize?: number;
		@Prop({ default: 0 }) marginTop?: number;
		@Prop({ default: 0 }) marginBottom?: number;

		private logout() {
			this.$emit('logout');
		}

		private close() {
			this.$emit('close');
		}

		closeFromMask() {
			if (this.closeButton) {
				this.$emit('close');
			}
		}

		private endSession() {
			this.$emit('endSession');
		}
	}
